import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import a1 from "../../assets/gw.png";
import { Link } from "react-router-dom";

const container = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.3 },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.6, ease: "easeOut" },
  },
};

export default function CampusIntro() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-120px" });

  return (
    <section ref={ref} className="bg-white py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">

        {/* IMAGE */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="relative order-1 lg:order-2 flex justify-center items-center"
        >
          <img
            src={a1}
            alt="GW Logo"
            className="w-full max-w-[420px] object-contain opacity-70 drop-shadow-lg"
          />
        </motion.div>

        {/* TEXT */}
        <motion.div
          variants={container}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="order-2 lg:order-1"
        >
          <motion.h2
            variants={fadeUp}
            className="text-3xl sm:text-4xl font-bold leading-tight"
          >
            Build Your Global Career Path
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="text-gray-600 mt-6 max-w-xl"
          >
            Good Will Global Solutions provides expert overseas education consultancy, helping students choose the right universities and courses.
            We support the complete study abroad process, including admissions, visa guidance, documentation, and pre-departure preparation.
          </motion.p>

          <div className="grid grid-cols-2 gap-4 mt-8">
            {[
              "Door-to-Door Counselling",
              "University Selection",
              "Test Preparation",
              "Application Assistance",
              "Visa Guidance",
              "Post-Arrival Support",
            ].map((item, i) => (
              <motion.div
                key={i}
                variants={fadeUp}
                className="flex items-center gap-3 text-sm sm:text-base"
              >
                <span className="bg-[#203594] text-white w-6 h-6 flex items-center justify-center rounded-full text-sm">
                  ✓
                </span>
                {item}
              </motion.div>
            ))}
          </div>

          <motion.button
            variants={fadeUp}
            className="mt-10 bg-[#203594] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#182c7d] transition"
          >
            <Link to="/about">More About Us</Link>
          </motion.button>
        </motion.div>

      </div>
    </section>
  );
}
